module.exports = __webpack_public_path__ + "static/media/role_assign_image.ef34b122.png";